import React from 'react';
import PropTypes from 'prop-types';
import { PageContext } from './PageContext';
import { st, classes } from './Page.st.css.js';
export const PageSticky = ({ children, className, style, ...props }) => {
    return (React.createElement(PageContext.Consumer, null, ({ stickyStyle }) => {
        let result;
        if (typeof children === 'function') {
            result = children({ style: style ?? {}, className: classes.sticky });
        }
        else {
            result = (React.createElement("div", { className: st(classes.sticky, {}, className), style: { ...stickyStyle, ...style }, ...props }, children));
        }
        return result;
    }));
};
PageSticky.displayName = 'Page.Sticky';
PageSticky.propTypes = {
    children: PropTypes.element.isRequired,
    style: PropTypes.object,
};
//# sourceMappingURL=PageSticky.js.map